import { filterRecords } from '../filters';
import { FilterList } from 'filters/types';
import { Formatter } from 'formatters/types';
import { StorageApi } from 'storage/types';
import { ObserverApi } from 'observers/types';

import { ReceiverApi, ReceiverOptions } from './types';
import { EVENT_ADDED_XHR_RECORD } from '../constants';
import { Masks } from '../masked/types';

/**
 * Receiver
 */
export class Receiver implements ReceiverApi {
  filters: FilterList;

  formatter: Formatter;

  storage: StorageApi;

  observer: ObserverApi;

  masks: Masks;

  /**
   * @param Options.filters
   * @param Options.formatter
   * @param Options.Storage
   * @param Options.Observer
   * @param Options.filters.filters
   * @param Options.filters.formatter
   * @param Options.filters.Storage
   * @param Options.filters.Observer
   * @param Options.filters.masks
   */
  constructor({
    filters,
    formatter,
    Storage,
    Observer,
    masks,
  }: ReceiverOptions) {
    this.filters = filters;
    this.formatter = formatter;
    this.storage = new Storage();
    this.observer = new Observer();
    this.masks = masks;
  }

  /**
   *
   * @private
   */
  private onAddedXhrRecord = () => {
    const filteredRecord = filterRecords(
      [this.observer.getLastRecord()],
      this.filters,
    )[0];

    this.storage.addRecord(filteredRecord);
  };

  /**
   *
   */
  handleStartLogging() {
    document.addEventListener(EVENT_ADDED_XHR_RECORD, this.onAddedXhrRecord);
    this.observer.start();
  }

  /**
   *
   */
  handleStopLogging() {
    this.observer.stop();
    document.removeEventListener(EVENT_ADDED_XHR_RECORD, this.onAddedXhrRecord);
  }

  /**
   *
   */
  getLogs = () => this.formatter(this.storage.getRecords(), this.masks);

  /**
   *
   */
  storageSize = () => this.storage.getRecords().length;

  /**
   *
   */
  clearStorage() {
    this.storage.clearRecords();
  }
}
